<template>
  <DxPopup @hidden="onHidden" :visible="showNoticeListPop" :show-close-button="true" :show-title="true" title="HiP Notice List" height="auto" width="1280" container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical
          :headerTitle="menuTitle"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12">
                <DxDataGrid
                  :ref="noticeRef"
                  :data-source="noticeList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  @rowClick="noticeRowClick"
                >
                  <DxPager :show-page-size-selector="false"/>
                  <DxPaging :page-size="10" />
                  <DxColumn data-field="bulletinNo" caption="Notice No" width="13%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="title" caption="Title" width="61%" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="stDte" caption="From" width="13%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="fiDte" caption="Until" width="13%" data-type="string" alignment="center" :allow-editing="false" />
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>

    <noticeContentsPop :showNoticeContentsPop.sync="showNoticeContentsPop" :bulletinNo="selectedNotice.bulletinNo" :title="selectedNotice.title" />
  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import BaseDataGrid from '@/components/base/BaseDataGrid'
import { DxPopup } from 'devextreme-vue/popup'
import { getNoticeList } from '@/api/view/hycot/Z/admZ000'
import noticeContentsPop from '@/views/hycot/Z/popup/noticeContentsPop'

export default {
  name: 'noticeListPop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    noticeContentsPop
  },
  props: {
    showNoticeListPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
     return {
       menuTitle: 'HyCOT Notice List',//this.$route.meta.title,
       userId: this.$store.state.user.userId,
       noticeRef: 'noticeRef',
       noticeList: [],
       selectedNotice: {},
       showNoticeContentsPop: false
     }
  },
  computed: {
    noticeInstance() {
      return this.GetDataGrid(this.noticeRef)
    }
  },
  watch: {
    'showNoticeListPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      this.noticeInstance.option('defaultPaging', false)

      this.retrieve()
    },
    clearData() {
      this.noticeList = []
      this.selectedNotice = {}
      this.noticeInstance.clearSelection()
    },
    async retrieve() {
      this.openLoading()
      this.clearData()
      
      await getNoticeList().then(res => {
        // console.log('res', res)

        this.noticeList = res.list
      }).finally(() => {
        this.endLoading()
      })
    },
    noticeRowClick(e) {
      if (e.rowIndex >= 0) {
        if (e.data) {
          this.selectedNotice = e.data
        } else {
          this.selectedNotice = {}
        }

        // console.log('this.selectedNotice', this.selectedNotice)

        this.showNoticeContentsPop = true
      }
    },
    onHidden(e) {
      this.$emit('update:showNoticeListPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>